const KEY_PREFIX = "Stitch-";

function getKey(key: string) {
  return `${KEY_PREFIX}${key}`;
}

const storage = {
  getItem: async (name: string): Promise<string | null> => {
    const prefixedKey = getKey(name);
    const value = localStorage.getItem(prefixedKey);
    return value;
  },
  setItem: async (name: string, value: string): Promise<string | null> => {
    const prefixedKey = getKey(name);
    localStorage.setItem(prefixedKey, value);
    return localStorage.getItem(prefixedKey);
  },
  removeItem: async (name: string): Promise<string | null> => {
    const prefixedKey = getKey(name);
    localStorage.removeItem(prefixedKey);
    return null;
  },
};

export const chromeStorage = {
  getItem: async (name: string): Promise<string | null> => {
    const result = await chrome.storage.local.get(name);
    return result[name] ?? null;
  },
  setItem: async (name: string, value: string): Promise<string | null> => {
    await chrome.storage.local.set({ [name]: value });
    return chromeStorage.getItem(name);
  },
  removeItem: async (name: string): Promise<string | null> => {
    const value = chromeStorage.getItem(name);
    await chrome.storage.local.remove(name);
    return value;
  },
};

export default storage;
